import { useState, useEffect, useRef, useCallback } from "react";
import { getCurrentJwt, getCurrentRefreshToken, setCurrentJwt, setCurrentRefreshToken } from "../utils/helpers/jwt.helpers"
//import { modoLocal, loginPath } from "utils/helpers/enviroment.helpers"
import { useNavigate } from 'react-router-dom'
import { refreshAuth } from "../services/auth.service";

export const useFetch = (url) => {

  // console.count("%c Se ejecutó useFetch", 'background: #222; color: #bada55');

  const abortController = useRef(null);
  const signal = useRef(null);
  const jwtToken = useRef(null);
  const navigate = useNavigate();

  const [error, setError] = useState(null);         //Guardará el error, en caso en que la petición falle
  const [loading, setLoading] = useState(false);    //Guarda el estado de si cargó o no la petición, para después saber si pintar o no la información

  // useEffect(()=> console.count("Render useFetch"))

  const fetchData = useCallback(async (ruta, callbackSuccess, callbackError, options) => {
    
    setLoading(true);

    if(!jwtToken.current) { //No debería hacer la redirección desde acá
      console.log("NO TIENE TOKEN - REDIRECCIÓN");
      setLoading(false);
      navigate(window.__CONFIG__.loginPath || "/");
      return;
    }

    const defaultHeader = {
      accept: "application/json",
      'Content-Type': 'application/json',
      Authorization: "Bearer " + jwtToken.current
    };

    options.method = options.method || "GET";
    options.headers = options.headers ? {...defaultHeader, ...options.headers} : defaultHeader;
    options.body = JSON.stringify(options.body) || false;
    
    if(!options.body) delete options.body;                  //Para no envíar el body vacío o false

    // console.log("options", options);
    // console.log("url + ruta", url + ruta);

    try {
      const res = await fetch(url + ruta, { method: options.method, body:options.body, headers: options.headers, signal: signal.current }); 
      
      console.log("res", res);

      if (res.status === 401) {
        console.log("Se venció la sesión - ERROR 401", res.headers);
        
        const refreshToken = getCurrentRefreshToken();
    
        const refreshResponse = await refreshAuth(jwtToken.current, refreshToken);
    
        if (!refreshResponse.ok) {
          // Si el refresh falla, lanzar error
          const err = new Error("Error al refrescar el token");
          err.status = refreshResponse.status || "00";
          err.statusText = refreshResponse.statusText || "Error de autenticación";
          throw err;
        }
    
        const jsonRefreshResponse = await refreshResponse.json();
    
        console.log("jsonRefreshResponse", jsonRefreshResponse);
        setCurrentJwt(jsonRefreshResponse.token);
        setCurrentRefreshToken(jsonRefreshResponse.refreshToken);
        
        // Actualizar el token en el ref
        jwtToken.current = jsonRefreshResponse.token;
        
        // Reintentar la petición con el nuevo token, pasando los callbacks
        return await fetchData(ruta, callbackSuccess, callbackError, {
          ...options,
          headers: {
            ...options.headers,
            Authorization: "Bearer " + jsonRefreshResponse.token
          }
        });
      }

      if (!res.ok) {                                          //Si la respuesta no está ok, lanzo un error
        const err = new Error("Error en la petición Fetch");
        err.status = res.status || "00";                      //Con el "00" asumimos que la API no me trajo ningún status de error
        err.statusText = res.statusText || "Ocurrió un error";//Está el operador de "cortocircuito" (||), porque hay APIs que no devuelven dicho atributo.
        throw err;
      }

      const json = await res.json();

      if (!signal.aborted) {  //Pregunta si todo salió bien
        setError(null);
        if(callbackSuccess) callbackSuccess(json)
      }
    } catch (error) {
      if (!signal.aborted) { //Si es un error de otro tipo que no sea aborted
        setError(error);
        if(callbackError) callbackError(error);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  }, [url])
  
  useEffect(() => {
    abortController.current = new AbortController();  //Es para cuando en el lado del servidor no hay respuesta y se queda intentando acceder por siempre, con esto se puede cancelar dicha petición
    signal.current = abortController.current.signal;  
    jwtToken.current = getCurrentJwt();
    console.log("jwtToken.current en useEffect", jwtToken.current);

    return () => {
      abortController.current.abort(); //Para que se ejecute al "desmontar"
    }
  }, []);

  const get = (ruta, callbackSuccess, callbackError, options = {}) => fetchData(ruta, callbackSuccess, callbackError, options);

  const post = (body, callbackSuccess, callbackError, ruta = '') => fetchData(ruta, callbackSuccess, callbackError, { method: "POST", body: body });

  const del = (ruta, callbackSuccess, callbackError, options = null) => fetchData(ruta, callbackSuccess, callbackError, options || { method: "DELETE" });
  
  const put = (ruta, body, callbackSuccess, callbackError, options = null) => fetchData(ruta, callbackSuccess, callbackError, options || { method: "PUT", body: body });

  const patch = (ruta, body, callbackSuccess, callbackError, options = null) => fetchData(ruta, callbackSuccess, callbackError, options || { method: "PATCH", body: body});

  return {
    get,
    post,
    put,
    del,
    patch,
    error, 
    loading 
  };
};